export default __webpack_public_path__ + "static/main_desktop_v3_en-2f78a12b0733114c35c126538236dd70.mp4";